<!-- <dashboardnav>

</dashboardnav> -->


<main class="main_content">

      
   
  <div class="display_selection" *ngIf="this.RoleForStaffDataMajors.length > 0" >
      <div class="the_card">
        <div class="top_title">
          <h2 class="title">Quick links</h2>
          <em  class="ti-close"></em>
        </div>

        <div class="contain_template" >

          <div *ngFor="let menu of this.RoleForStaffDataMajors; let g = index" >
            <h2 class="item" (click)="selectMenu(menu)">
              <span class="name" >{{menu.name}}</span>
              <span class="description">{{menu.MenuDesc}}</span>
            </h2>
          </div>
          
          <!-- <mat-radio-group class="example-radio-group" >
            <mat-radio-button class="example-margin" [value]="menu.id"></mat-radio-button>
            <mat-radio-button class="example-margin" value="Female" > <h2 class="item">
              <span class="name">Principles of Macro Economics</span>
              <span class="description">Lorem ipsum dolor sit, amet consectetur adipisicing elit. Facilis, deserunt!</span>
            </h2></mat-radio-button>
            <mat-radio-button class="example-margin" value="Other" ><h2 class="item">
              <span class="name">Principles of Macro Economics</span>
              <span class="description">Lorem ipsum dolor sit, amet consectetur adipisicing elit. Facilis, deserunt!</span>
            </h2></mat-radio-button>
          </mat-radio-group> -->
        </div>

        
         
        
       
        

        <span class="check_default">

          <mat-checkbox [(ngModel)]="setAsdefault"
                   
                    (ngModelChange)="setDefaultChanged()">
                    Set as default
         </mat-checkbox>

          <!-- <input type="checkbox" name="" id="" [(ngModel)]="setAsdefault" />
          Set as default -->
        </span>
      </div>
    </div>
</main>



 





